<template>
    <div>
      <modal-grid
        :title="'Lista de Seleccionados'"
        :visible="visibleModal"
        :data="selectedBox"
        @hide="visibleModal = !visibleModal"
      ></modal-grid> 
      <modal-form
        :visible="visibleModalForm"
        :title="ingreso.id == null ? 'Registrar Ingreso' : 'Actualizar Ingreso'"
        :size="'lg'"
        @hide="closeModalForm"
      >
        <fieldset class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <legend>Datos Generales:</legend>
          <a-spin :spinning="success">
            <div class="container">
              <div class="d-flex flex-row-reverse bd-highlight">
                <small><strong>Los campos con (*) son obligatorios.</strong></small>
              </div>
              <b-form @submit.stop.prevent="submitIngreso">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <strong>
                      <label for="fecha_solicitud">Fecha de Solicitud * :</label>
                    </strong>
                    <b-form-group label-for="fecha_solicitud" :invalid-feedback="errors.first('fecha_solicitud')" :state="!errors.has('fecha_solicitud')">
                      <b-form-input 
                        v-model="ingreso.fecha_solicitud" 
                        :state="errors.has('fecha_solicitud') ? false : null"
                        v-validate="'required'"
                        data-vv-name="fecha_solicitud"
                        data-vv-as="fecha solicitud"
                        type="date"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <strong>
                      <label for="observacion">Observaciones :</label>
                    </strong>
                    <b-form-group label-for="observacion" :invalid-feedback="errors.first('observacion')" :state="!errors.has('observacion')">
                      <b-form-textarea 
                        style="border-color: #308e31;outline: 0px;box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset, #9e020761 0px 0px 8px;"
                        v-model="ingreso.observacion" 
                        :state="errors.has('observacion') ? false : null"
                        v-validate="'max:128'"
                        data-vv-name="observacion"
                        data-vv-as="observaciones"
                      ></b-form-textarea>
                    </b-form-group>
                  </div>
                </div>
                <hr style="border: 1px solid rgb(222, 222, 222);">
                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                >
                  Debe seleccionar al menos una caja para la solicitud de ingreso.
                </b-alert>
                <span class="font-weight-bold">Total cajas({{ totalBox }})</span>
                <div class="d-flex flex-sm-row flex-column bg-secondary">
                  <div class="mr-auto p-2">
                    <b-button @click="visibleModal = true" size="sm" squared variant="outline-danger" class="mr-2">
                      <i class="fa fa-check-square"></i>
                      ({{ selectedBox.length }}) Seleccionados
                    </b-button>
                  </div>
                  <div class="p-2">
                    <b-button size="sm" title="Actualizar Tabla" @click="reloadTable" variant="dark" class="mr-2">
                      <i class="fa fa-repeat"></i>
                    </b-button>
                  </div>
                </div>
                <vue-custom-scrollbar class="scroll-area">
                  <kendo-datasource
                    ref="data-box"
                    :schema-data="'data'"
                    :transport-read="{ url: `${url}/cajas/pendientes`, beforeSend: readData }"
                    :server-filtering="true"
                    :server-sorting="true"
                    :schema-model-fields="dsSchemaFields"
                  ></kendo-datasource>
                  <kendo-grid 
                    ref="gridBox"
                    :data-source-ref="'data-box'"
                    :no-records="true"
                    :messages-no-records="'NO EXISTEN RESULTADOS'"
                    :filterable="filterableConfig"
                    :navigatable="true"
                    :sortable="true"
                    :resizable="true"
                    @change="onChange"
                    @databound="dataBound"
                  >
                    <kendo-grid-column :selectable="true" :width="30"></kendo-grid-column>
                    <kendo-grid-column
                      :field="'gestion'"
                      :title="'GESTIÓN'"
                      :width="80"
                      :filterable-cell-operator="'contains'"
                      :filterable-cell-suggestion-operator="'contains'"
                    ></kendo-grid-column>
                    <kendo-grid-column
                      :field="'cod_interno'"
                      :title="'INTERNO'"
                      :width="80"
                      :filterable-cell-operator="'contains'"
                      :filterable-cell-suggestion-operator="'contains'"
                    ></kendo-grid-column>
                    <kendo-grid-column
                      :field="'cant_carpetas'"
                      :title="'CARP. INICIAL'"
                      :width="70"
                      :filterable="false"
                    ></kendo-grid-column>
                    <kendo-grid-column
                      :field="'estado'"
                      :title="'ESTADO'"
                      :width="70"
                      :template="templateState"
                      :filterable="false"
                    ></kendo-grid-column>
                  </kendo-grid>
                </vue-custom-scrollbar>
                <div class="row my-2">
                  <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                    <b-button 
                      type="submit" 
                      class="float-right" 
                      variant="success"
                    ><i class="fa fa-check-circle" aria-hidden="true"></i> {{ ingreso.id == null ? 'REGISTRAR' : 'ACTUALIZAR' }}</b-button>
                    <b-button @click="closeModalForm" class="mr-2 float-right" variant="secondary"><i class="fa fa-times-circle" aria-hidden="true"></i> CANCELAR</b-button>
                  </div>
                </div>
              </b-form>
            </div>
          </a-spin>
        </fieldset>
      </modal-form>
      <b-card no-body header-bg-variant="light">
        <template v-slot:header>
          <div>
            <span class="text-dark font-size-24 font-weight-bold">
              LISTA DE INGRESOS ALMACÉN
            </span>
            <button
              @click="openModalForm"
              type="button"
              class="btn btn-success btn-with-addon mr-auto text-nowrap pull-right"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-plus-circle" />
              </span>
              Registrar Nuevo 
            </button>
          </div>   
        </template>
        <b-tabs card active-nav-item-class="font-weight-bold text-uppercase text-black">
          <b-tab title="General" :title-link-class="'text-black'" lazy>
            <a-skeleton active :loading="tabGeneral"/>
            <grid-general v-show="!tabGeneral" v-on:general='general' v-on:edit-income="editIngreso"></grid-general>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </template>
    
  <script>
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import permission from '../../mixins/permission'
    import { API_URL } from "../../services/config"
    import GridGeneral from '../../components/agency/GridGeneral.vue'
    import ModalGrid from "../../components/widgets/Modals/ModalGridSelectedMove"
    import ModalForm from "../../components/widgets/Modals/ModalForm"
    import Ingreso from '../../models/Ingreso'
    import IncomeService from '../../services/income.service'
  
    export default {
      components: {
        'grid-general': GridGeneral,
        "modal-grid": ModalGrid,
        "modal-form": ModalForm,
        vueCustomScrollbar,
      },
  
      mixins: [permission],
  
      data() {
        return {
          tabGeneral: true,
          ingreso: new Ingreso(),
          success: false,
          visibleModal: false,
          visibleModalForm: false,
          url: API_URL,
          dsSchemaFields: {
            gestion: { type: "string" },
            cod_interno: { type: "string" },
            cant_carpetas: { type: "string" },
            stock_carpetas: { type: "string" },
            estado: { from: "estado.title" },
          },
          filterableConfig: {
            mode: "row",
            operators: {
              string: {
                qe: "Es igual a",
                neq: "No es igual a",
                contains: "Contiene",
                doesnotcontain: "No contiene",
                startswitch: "Comienza con",
                endswitch: "Termina en"
              },
              date: {
                lte: "Antes o igual a",
                gte: "Después o igual a"
              }
            }
          },
          selectedBox: [],
          totalBox: 0,
          dismissSecs: 5,
          dismissCountDown: 0
        }
      },
  
      methods: {
        general(e) {
          this.tabGeneral = e
        },
  
        openModalForm() {
          this.visibleModalForm = true
        },
  
        closeModalForm() {
          this.visibleModalForm = false
          this.ingreso = new Ingreso()
          this.selectedBox = []
        },
  
        templateState(dataItem) {
          switch (dataItem.estado) {
            case "PENDIENTE":
              return (
                "<span class='badge badge-success'>" +
                kendo.htmlEncode(dataItem.estado) +
                "</span>"
              );
              break;
            case "EN ALMACÉN":
              return (
                "<span class='badge badge-danger'>" +
                kendo.htmlEncode(dataItem.estado) +
                "</span>"
              );
              break;
            case "RETIRADA":
              return (
                "<span class='badge badge-warning'>" +
                kendo.htmlEncode(dataItem.estado) +
                "</span>"
              );
              break;
            default:
              return (
                "<span class='badge badge-success'>" +
                kendo.htmlEncode(dataItem.estado) +
                "</span>"
              );
          }
        },
  
        reloadTable() {
          this.$refs.gridBox.kendoWidget().dataSource.filter({})
        },
  
        readData: function(xhr) {
          let self = this
          xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("access_token"))
          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
          xhr.setRequestHeader("Accept-Language", "en")
          xhr.setRequestHeader("Accept", "application/json")
          xhr.done(function(data) {
            self.totalBox = data.data.length
          })
          xhr.fail(function(data) {
            if (data.status === 403) self.$router.push({ path: '/system/403' })
            if (data.status === 401 || data.responseJSON.message == "Unauthenticated.") {
              self.$store.dispatch('responseMessage', {
                type: 'warning',
                text: 'No tiene una sesión activa, por favor vuelva a iniciar sesión.',
                title: 'Sesión Expirada!',
                modal: true
              })
              .then(async() => {
                await self.$store.dispatch('cleanSession')
                self.$router.push({ path: '/system/login' })
              })
            }
          })
        },
  
        onChange(e) {
          let vm = this
          let grid = e.sender
          let items = grid.items()
          items.each(function(idx, row) {
            let idValue = grid.dataItem(row).get("id")
            let index = vm.selectedBox.findIndex(x => x.id == idValue)
            if (row.className.indexOf("k-state-selected") >= 0) {
              let {parent, dirty, dirtyFields, _events, _handlers, uid,...obj} = grid.dataItem(row)
              const flag = vm.selectedBox.some(item => item.id === obj.id)
              if (!flag) vm.selectedBox.push(obj)
            } else if (index > -1) {
              vm.selectedBox.splice(index, 1)
            }
          })
        },
  
        dataBound(e) {
          let vm = this
          let grid = e.sender
          let items = grid.items()
          let itemsToSelect = []
          items.each(function(idx, row) {
            let dataItem = grid.dataItem(row).get("id")
            let index = vm.selectedBox.some(item => item.id === dataItem)
            if (index) {
              itemsToSelect.push(row)
            }
          })
    
          e.sender.select(itemsToSelect)
        },
  
        countDownChanged(dismissCountDown) {
          this.dismissCountDown = dismissCountDown
        },
  
        async editIngreso(data) {
          this.$store.dispatch("showLoader")
          try {
            const response = await IncomeService.editIncome(data.id)
            if (response.status === 200) {
              this.ingreso.id = response.data.data.id
              this.ingreso.fecha_solicitud = response.data.data.fecha_solicitud
              this.ingreso.observacion = response.data.data.observacion
              this.selectedBox = response.data.data.cajas
              this.openModalForm()
              this.$store.dispatch("hideLoader")
            }
          } catch (err) {
            this.$store.dispatch("hideLoader")
          }
        },
  
        async submitIngreso() {
          if (this.selectedBox.length > 0) {
            this.$validator.errors.clear()
            this.success = true
            try {
              let data = {ingreso: this.ingreso, cajas: this.selectedBox.map(o => o.id)}
              if(this.ingreso.id) {
                this._save = await IncomeService.updateIncome(this.ingreso.id, data)
              } else {
                this._save = await IncomeService.storeIncome(data)
              }
              if (this._save.status === 201 || this._save.status === 200) {
                this.closeModalForm()
                this.success = false
                this.$bus.$emit('evn-reload')
                this.$message.success(this._save.data.message)
              }
            } catch (err) {
              if(err.response.status === 422) this.$setErrorsFromResponse(err.response.data)
              if (err.response.status === 406) {
                this.closeModalForm()
                this.$notification.warning({
                  message: 'Nota',
                  description: err.response.data.message,
                  duration: 10,
                })
              }
              this.success = false
            }
          } else {
            this.dismissCountDown = this.dismissSecs
          }
        }
      }
    }
  </script>
  <style scoped src="../../assets/css/grid.css"></style>
  <style scoped>
    fieldset {
      background-color: #f9f9f9;
      border-radius: 4px;
    }
  
    legend {
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 4px;
      color: #000;
      font-size: 17px;
      font-weight: bold;
      padding: 3px 5px 3px 7px;
      width: auto;
    }
  
    .scroll-area {
      position: relative;
      margin: auto;
      height: 200px;
    }
  </style>